"use client";

/**
 * Marketing landing-page entry point. Picks the mobile or desktop HERO assembly
 * based on the viewport. Rendered by `(public)/page.tsx` for visitors on `/`.
 */
import type { ReactNode } from "react";

import { MarketingPageView } from "@/lib/marketing-analytics/marketing-page-view";
import { useMobileViewport } from "@/lib/use-mobile-viewport";
import { HeroDesktop } from "./hero/hero-desktop";
import { HeroMobile } from "./hero/hero-mobile";

export function MarketingHome(): ReactNode {
  const isMobile = useMobileViewport();
  return (
    <>
      <MarketingPageView funnel="website_demo" step={0} />
      {isMobile ? <HeroMobile /> : <HeroDesktop />}
    </>
  );
}
